var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldRam2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.994 20.987 7.98 19a2 2 0 0 1 2-2h4.01c1.1 0 1.99.89 2 1.99l.02 1.98a1 1 0 0 1-1 1.01H8.994a1 1 0 0 1-1-.993z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 12.17c0 .53.21 1.04.59 1.42l.82.82c.38.38.59.89.59 1.42V17c0 2.52-1.09 4.31-3.49 4.83L17 18.98c-.02-1.64-1.37-2.98-3-2.98H9.99c-1.66 0-3 1.35-3 3v1.872a.5.5 0 0 1-.803.398C4.396 19.903 3.5 18.48 3.5 17V7c0-2.61 1.12-4.46 3.73-4.89L7.19 4.9c-.01.47.16.92.48 1.26.33.34.76.53 1.27.54.65 0 1.21-.34 1.5-.86.07.11.14.2.23.29.32.34.76.54 1.27.55.64 0 1.21-.35 1.51-.88.06.1.14.19.22.28.32.34.76.54 1.27.55.96 0 1.73-.75 1.75-1.72l.034-1.902a.5.5 0 0 1 .784-.403C19.503 3.983 20.5 5.447 20.5 7v1c0 .55-.45 1-1 1s-1 .45-1 1v2.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.69 4.96c-.01.41-.34.74-.75.74h-.01a.751.751 0 0 1-.74-.77V2.507a.5.5 0 0 1 .496-.5l.542-.004a.5.5 0 0 1 .503.509L9.69 4.96zM12.69 4.95c-.01.4-.34.73-.75.73h-.01a.749.749 0 0 1-.74-.76V2.5a.5.5 0 0 1 .5-.5h.541a.5.5 0 0 1 .5.508L12.69 4.95zM15.69 4.89c-.01.41-.34.74-.75.74h-.01a.749.749 0 0 1-.74-.76V2.503a.5.5 0 0 1 .503-.5l.541.004a.5.5 0 0 1 .497.508L15.69 4.89z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldRam2);
export default __webpack_public_path__ + "static/media/vuesax-bold-ram-2.bf815ed8d16b84702f2cafe9ae9e2ac4.svg";
export { ForwardRef as ReactComponent };